<ion-item *ngIf="departureTicketInfo">
  <ion-icon src="assets/icons/departure-ticket-info/lift.svg" slot="start" size="large"></ion-icon>
  <ion-label class="ion-text-wrap">
    <ng-container *ngIf="departureTicketInfo.LiftInfos">
      <h2>
        <strong translate>Mobile.ElevatorBrand</strong>
      </h2>
      <h2>{{ departureTicketInfo.LiftInfos }}</h2>
    </ng-container>
    <ng-container *ngIf="fireColumns">
      <h2>
        <strong translate>Mobile.DryRiser</strong>
      </h2>
      <h2>{{ fireColumns }}</h2>
    </ng-container>
    <ng-container *ngIf="departureTicketInfo.Access">
      <h2>
        <strong translate>Mobile.MachineryAccess</strong>
      </h2>
      <h2>{{ departureTicketInfo.Access }}</h2>
    </ng-container>
  </ion-label>
</ion-item>
